import { Box, Icon, Text, ToggleTip } from '@betterment/samba-react';

import { BonusPayrollContributionRow } from './BonusPayrollContributionRow';
import { PayrollContributionConfigRow } from './PayrollContributionConfigRow';
import { bonusEqualsBase } from './payrollContributionUtils';

import { PayrollContributionConfigFragment } from '../../../graphql/fragments/payrollContributionConfig.generated';

type Props = {
  configs: PayrollContributionConfigFragment[];
};

export const PayrollConfigsList = ({ configs }: Props) => {
  const hasUnequalBonus = configs.some(config => config.bonusValue && !bonusEqualsBase(config));
  const configsWithBonusValue = configs.filter(config => config.bonusValue);

  let displayText;
  if (hasUnequalBonus) {
    displayText = 'Base pay (per pay period)';
  } else if (configsWithBonusValue.length > 0) {
    displayText = 'Base pay and bonus (per pay period)';
  } else {
    displayText = 'Base pay (per pay period)';
  }

  return (
    <>
      <Box
        css={{
          display: 'flex',
          flexDirection: 'row',
          paddingTop: 'space.300',
          paddingLeft: 'space.300',
          paddingRight: 'space.300',
        }}
      >
        <Icon name="ArrowCirclePlus" size="small" />

        <Box>
          <Box css={{ paddingBottom: 'space.300', px: 'space.150' }}>
            {configs.map(config => (
              <PayrollContributionConfigRow key={config.id} config={config} />
            ))}
            <Box style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <Text variant="text50" color="text.weak">
                {displayText}
              </Text>

              {!hasUnequalBonus && configsWithBonusValue.length > 0 && (
                <ToggleTip>
                  <ToggleTip.Trigger iconName="InfoCircle" label="Base and bonus information" />
                  <ToggleTip.Content css={{ maxWidth: '300px' }}>
                    Bonus pay and timing are set by your employer. Reach out to them if you have questions.
                  </ToggleTip.Content>
                </ToggleTip>
              )}
            </Box>
          </Box>

          {hasUnequalBonus && (
            <Box css={{ px: 'space.150', paddingBottom: 'space.300' }}>
              {configsWithBonusValue.map(config => (
                <BonusPayrollContributionRow key={`${config.id}-bonus`} config={config} />
              ))}
              <Box style={{ display: 'flex', alignItems: 'center', gap: '4px', paddingBottom: 'space.0' }}>
                <Text variant="text50" color="text.weak">
                  Bonus
                </Text>
                <ToggleTip>
                  <ToggleTip.Trigger iconName="InfoCircle" label="Bonus information" />
                  <ToggleTip.Content css={{ maxWidth: '300px' }}>
                    Bonus pay and timing are set by your employer. Reach out to them if you have questions.
                  </ToggleTip.Content>
                </ToggleTip>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};
